(function () {
  'use strict';

  d3.chart('ChartBase').extend('BarChartWithAxes', {
    initialize : function (options) {
      var plot = this;
      options = options || {};

      _.defaultsDeep(options, {
        xAxis: true,
        yAxis: true
      });

      var margin = {
        top: 20,
        right: 10,
        bottom: 20,
        left: 40
      };

      plot.padding(margin);

      plot.x = d3.scale.ordinal();

      plot.y = d3.scale.linear();

      plot.axisSvgs = {
        x : plot.wrap.append('g').classed('chart-axis x', true),
        y : plot.wrap.append('g').classed('chart-axis y', true)
      };

      plot.axes = {
        x : d3.svg.axis().scale(plot.x).orient('bottom').tickFormat(""),
        y : d3.svg.axis().scale(plot.y).orient('left').ticks(3).tickFormat(options.metricValuesFormat)
      };

      if (!options.xAxis) {
        plot.axisSvgs.x.style('display', 'none');
      }

      if (!options.yAxis) {
        plot.axisSvgs.y.style('display', 'none');
      }

      plot.layers = {
        bars : plot.wrap.append('g').classed('bars', true)
      };

      plot.layer('bars', plot.layers.bars, {
        dataBind : function (data) {
          return this.selectAll('.bar')
              .data(data);
        },
        insert : function () {
          var bar = this;

          bar.append("g")
              .attr("class", "bar")
              .append("rect");

          return bar;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge: function () {
            var that = this;
            if(plot.h > 0) {
              that.select("rect")
                  .attr("x", function (d) {
                    return plot.x(d["label"]);
                  })
                  .attr("y", function (d) {
                    return d["value"] && plot.y(d["value"]);
                  })
                  .attr("width", plot.x.rangeBand())
                  .attr("height", function (d) {
                    return d["value"] && (plot.h - plot.y(d["value"]));
                  })
                  .attr("fill", function (d) {
                    return d["color"];
                  })
            }
          }
        }
      });

      function calcRange() {

        plot.x.rangeRoundBands([0, plot.w], .6);
        plot.y.range([plot.h, 0]);

        if (!options.showGrid) {
          plot.axes.y.tickPadding(10).innerTickSize(-plot.w);
        }

        plot.axisSvgs.x
            .translate(0, plot.y.range()[0])
            .call(plot.axes.x);

        plot.axisSvgs.y
            .call(plot.axes.y);

        // Transform graph
        d3.select("svg").select("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      }

      plot.on('change:width', calcRange)
          .on('change:height', calcRange)
          .on('change:data', calcRange);
    },
    transform: function (data) {
      var plot = this;

      if (data !== plot.data) {

        var chartData = {};
        chartData.xLabel = _.map(data, 'label');
        chartData.data = _.map(data, 'value');


        plot.data = [];

        data.forEach(function (item) {
          plot.data.push(item);
        });

        plot.x.domain(_.map(plot.data, 'label'))
            .rangeRoundBands([0, plot.w]);

        plot.y.domain([0, _.ceil(d3.max(_.map(plot.data, 'value')))])
            .range([plot.h, 0]);
      }

      return data;
    }
  });

})();